import React from 'react';
import { GiftBagOrBox } from '../../BagOrBox';
import { useGiftWrapContext } from '../../../context/GiftWrapContext';
import styles from './firstPage.module.css';
import { GiftCard } from '../../Card';
import { useScrollToElement } from './useScrollToElement';
import { GiftWrapLoader } from '../../GiftWrapLoader';
import { usePage } from '../../../context/PageContext';
import { isBoxRoleHandle } from '../../../packaging/roles';
/*
 * GiftWrapBody component displays the body for the gift wrap journey, including navigation and toast notifications.
 *
 * @param {Object} props - Component props
 * @returns {import('react').JSX.Element}
 */
export function FirstPage({ ...rest }) {
  const { wrapOptions, personalisationChoices, loading } = useGiftWrapContext();
  const { contentRef, scrollToElement } = useScrollToElement();
  const { goToPage } = usePage();
  const bagsOfBoxes = wrapOptions.filter((option) => option.type === 'bag' && !isBoxRoleHandle(option.handle));
  const boxes = wrapOptions.filter((option) => option.type === 'box' && !isBoxRoleHandle(option.handle));
  const cards = wrapOptions.filter((option) => option.type === 'card');
  const stampBags = wrapOptions.filter((option) => option.type === 'stamp_bag');
  const stampBoxes = wrapOptions.filter((option) => option.type === 'stamp_box');

  return (
    <div ref={contentRef} className={styles['giftWrap__content']} style={{ ...rest }}>
      <GiftWrapLoader isVisible={loading} />
      <div className={styles['page--container']}>
        <div className={styles['giftWrap__content-header']}>
          <h3 className={styles['giftWrap__content-title']}>Gift Packaging (Optional):</h3>
          <span className={styles['giftWrap__content-subtitle']}>Select any combination</span>
        </div>

        <ul className={styles['giftWrap__content-products']}>
          {/* Gift wrap bags */}
          {bagsOfBoxes.map((product) => (
            <li
              key={`${product.product_id}-${personalisationChoices.length}`}
              className={styles['giftWrap__content-product-item']}
            >
              <GiftBagOrBox product={product} stamps={stampBags} onScrollToElement={scrollToElement} />
            </li>
          ))}

          {/* Gift wrap boxes */}
          {boxes.map((product) => (
            <li
              key={`${product.product_id}-${personalisationChoices.length}`}
              className={styles['giftWrap__content-product-item']}
            >
              <GiftBagOrBox product={product} stamps={stampBoxes} onScrollToElement={scrollToElement} />
            </li>
          ))}

          {/* Gift cards */}
          {/* {cards.map((product) => (
            <li
              key={`${product.product_id}-${personalisationChoices.length}`}
              className={styles['giftWrap__content-product-item']}
            >
              <GiftCard product={product} onScrollToElement={scrollToElement} />
            </li>
          ))} */}
        </ul>
      </div>
    </div>
  );
}
